import { render, staticRenderFns } from "./NewBoard.vue?vue&type=template&id=abe5cc42&scoped=true"
import script from "./NewBoard.vue?vue&type=script&lang=js"
export * from "./NewBoard.vue?vue&type=script&lang=js"
import style0 from "./NewBoard.vue?vue&type=style&index=0&id=abe5cc42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe5cc42",
  null
  
)

export default component.exports